module.exports = __webpack_public_path__ + "static/media/isotipo-tq-g.a40ac148.png";